module.exports = __webpack_public_path__ + "r-v3/img/stopwatch_blue.9d37a144.svg";